/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The ActorVo model module.
   * @module drill/model/ActorVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>ActorVo</code>.
   * @alias module:drill/model/ActorVo
   * @class
   * @param label {String} 角色名称
   * @param playable {Boolean} 可否扮演
   */
  var exports = function(label, playable) {
    var _this = this;

    _this['label'] = label;

    _this['playable'] = playable;
  };

  /**
   * Constructs a <code>ActorVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:drill/model/ActorVo} obj Optional instance to populate.
   * @return {module:drill/model/ActorVo} The populated <code>ActorVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'label')) {
        obj['label'] = ApiClient.convertToType(data['label'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'actorUri')) {
        obj['actorUri'] = ApiClient.convertToType(data['actorUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'playable')) {
        obj['playable'] = ApiClient.convertToType(data['playable'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * 角色名称
   * @member {String} label
   */
  exports.prototype['label'] = undefined;
  /**
   * 图片Uri
   * @member {String} actorUri
   */
  exports.prototype['actorUri'] = undefined;
  /**
   * 可否扮演
   * @member {Boolean} playable
   */
  exports.prototype['playable'] = undefined;



  export default exports;
;


